import { render, staticRenderFns } from "./Wardrobe.vue?vue&type=template&id=21677618&v-cloak=true&"
import script from "./Wardrobe.vue?vue&type=script&lang=js&"
export * from "./Wardrobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports